{
  "settlement-agency": "Agencia de Liquidación"
}
